import React, { useState, useEffect } from 'react';
import SidebarLayout from "components/Layout/Layout";
import { API_URL } from "env";
import { useNavigate } from 'react-router-dom';
import { PencilSimpleIcon, TrashSimpleIcon } from '@phosphor-icons/react'
import { Modal } from "antd";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";

const ListProduct: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(() => {
        const data = sessionStorage.getItem('rcmPage');
        return data ? Number(data) : 1;
    });
    const [count, setCount] = useState(0)
    const [count2, setCount2] = useState(0)
    const [lastPage, setLastPage] = useState(1);
    const [theme, setTheme] = useState("light");
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };
    const clearAllFilters = () => {
        setSearchText('');
    };
    const [searchText, setSearchText] = useState('');

    const fetchData = async (page = 1, limit = 10) => {
        try {
            setLoading(true);
            let url = `${API_URL}api/v1/be/recommendations?page=${page}&per_page=${limit}`;
            if (searchText.trim()) {
                url += `&title=${encodeURIComponent(searchText)}`;
            }
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const json = await response.json();
            setData(json.data.data || []);
            setCurrentPage(json.data.current_page || 1);
            setLastPage(Math.ceil(json.data.total / limit));
        } catch (err) {
            console.error("Lỗi khi gọi API:", err);
        } finally {
            setLoading(false);
        }
    };

    const clickPagination = (key: number) => {
        setCurrentPage(key)
        sessionStorage.setItem('rcmPage', JSON.stringify(key))
    }

    useEffect(() => {
        const data = sessionStorage.getItem('rcmPage');
        if (data) {
            setCurrentPage(Number(data));
        } else {
            setCurrentPage(1);
        }
    }, []);

    useEffect(() => {
        if (typeof currentPage === 'number') {
            fetchData(currentPage);
            setCount(count + 1)
        }
    }, [currentPage, count2]);

    useEffect(() => {
        if (count > 0) {
            setCurrentPage(1);
            setCount2(count2 + 1)
        }
    }, [searchText]);

    const handleDelete = async (id: number) => {
        Modal.confirm({
            title: "Xác nhận",
            content: "Bạn có chắc muốn xóa mục này không?",
            okText: "Xóa",
            cancelText: "Hủy",
            okButtonProps: { danger: true }, // nút Xóa màu đỏ
            onOk: async () => {
                try {
                    setLoading(true);
                    const response = await fetch(`${API_URL}api/v1/be/recommendations/${id}`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    });

                    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                    const json = await response.json();

                    if (json.status) {
                        Modal.success({
                            title: "Thành công",
                            content: "Xóa thành công!",
                        });
                        await fetchData(currentPage);
                    } else {
                        Modal.error({
                            title: "Thất bại",
                            content: "Xóa thất bại: " + (json.message || "Unknown error"),
                        });
                    }
                } catch (error: any) {
                    Modal.error({
                        title: "Lỗi",
                        content: "Lỗi khi xóa: " + error.message,
                    });
                } finally {
                    setLoading(false);
                }
            },
        });
    };

    return (
        <SidebarLayout
            title={<h4 className="text-2xl font-bold !m-0 py-4">Recommendation</h4>}
        >
            <div className="table-header-daily">
                <div className="flex items-center gap-10">
                    <h5 className="m-0">List</h5>
                    <div className="relative w-64">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-400">
                            <MagnifyingGlassIcon className="h-5 w-5" />
                        </span>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchText}
                            onChange={handleSearchChange}
                            className="w-full pl-8 pr-2 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        />
                    </div>
                </div>


                {(searchText) && (
                    <button
                        className="btn-clear-filters"
                        onClick={clearAllFilters}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Clear Filters
                    </button>
                )}
                <button
                    className="btn-add-daily"
                    onClick={() => navigate('/add-recomendation')}
                >
                    + Add
                </button>
            </div>

            <div className="table-wrapper-daily">
                {loading ? (
                    <p>Đang tải dữ liệu...</p>
                ) : (
                    <>
                        <table className="custom-table-daily">
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.id}</td>
                                            <td>{(() => {
                                                try {
                                                    const title = JSON.parse(item.title)
                                                    return title.vi || title.en
                                                } catch (e) {
                                                    return item.title
                                                }
                                            })()}</td>
                                            <td>
                                                <div className="action-menu-daily flex gap-2">
                                                    <p
                                                        onClick={() => navigate(`/add-recomendation/edit/${item.id}`)}
                                                        className="cursor-pointer p-2 rounded-[5px] m-0 hover:text-blue-700 hover:bg-blue-200 transition-all duration-500 flex items-center justify-center"
                                                    >
                                                        <PencilSimpleIcon size={18} fill={theme === 'dark' ? '#fff' : ''} />
                                                    </p>
                                                    <p
                                                        onClick={() => handleDelete(item.id)}
                                                        className="cursor-pointer p-2 rounded-[5px] m-0 text-red-700 hover:bg-red-200 transition-all duration-500 flex items-center justify-center"
                                                    >
                                                        <TrashSimpleIcon size={18} fill={theme === 'dark' ? '#fff' : ''} />
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center" }}>
                                            Không có dữ liệu
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "5px" }}>
                            <button
                                onClick={() => clickPagination(Number(currentPage) > 0 ? Number(currentPage) - 1 : 0)}
                                disabled={Number(currentPage) === 1}
                                style={{
                                    padding: "5px 10px",
                                    border: "1px solid #ccc",
                                    backgroundColor: Number(currentPage) === 1 ? "#f5f5f5" : "white",
                                    cursor: Number(currentPage) === 1 ? "not-allowed" : "pointer"
                                }}
                            >
                                « Prev
                            </button>
                            {Array.from({ length: lastPage }, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => clickPagination(i + 1)}
                                    style={{
                                        fontWeight: Number(currentPage) === i + 1 ? "bold" : "normal",
                                        background: Number(currentPage) === i + 1 ? "#1677ff" : "white",
                                        color: Number(currentPage) === i + 1 ? "white" : "black",
                                        padding: "5px 10px",
                                        border: "1px solid #ccc",
                                        cursor: 'pointer'
                                    }}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={() => clickPagination(Number(currentPage) + 1)}
                                disabled={Number(currentPage) === Number(lastPage)}
                                style={{
                                    padding: "5px 10px",
                                    border: "1px solid #ccc",
                                    backgroundColor: Number(currentPage) === lastPage ? "#f5f5f5" : "white",
                                    cursor: Number(currentPage) === Number(lastPage) ? "not-allowed" : "pointer",
                                }}
                            >
                                Next »
                            </button>
                        </div>
                    </>


                )}
            </div>
        </SidebarLayout>
    );
};

export default ListProduct;